import clsx from "clsx"
import "../assets/css/button.css"

const Button = ({ children, title, onlyBorder = false, custCls, processBtn = false, type, onClickBtn = () => { }, borderColor, bgColor, disabled = false, isSaving = false }) => {
  const handleClickBtn = () => {
    if (processBtn) onClickBtn()
  }

  return (
    <>
      {onlyBorder ? (
        <button onClick={handleClickBtn} type={type ? type : "button"} disabled={disabled || isSaving} className={clsx("w-full border-2 text-[#6e6060] font-agcasmlt", { "opacity-80 cursor-not-allowed": disabled || isSaving }, custCls)}>
          {children ? children : title}
        </button>
      ) : (
        <button onClick={handleClickBtn} type={type ? type : "button"} disabled={disabled || isSaving} className={clsx("w-full border-2 text-white font-agcasmlt flex justify-center", { "border-[#6e6060] bg-[#6e6060]": !borderColor, "opacity-60 cursor-not-allowed": disabled || isSaving }, borderColor, bgColor, custCls)}>
          <div className={clsx("btn-loader mr-2", { "hidden": !isSaving })}></div>
          {children ? children : title}
        </button>
      )}
    </>
  )
}

const LoadButton = ({ type = "button", isLoading = false, text = "", onClickBtn = () => { } }) => {
  const handleClickBtn = () => {
    onClickBtn()
  }

  return <button type={type} onClick={handleClickBtn} className={clsx("bg-[#b79858] font-agcasmlt font-light text-charcoal-black text-lg sm:text-xl lg:text-2xl pt-2 pb-1 px-8", { "flex justify-center opacity-60": isLoading })}>
    <div className={clsx("btn-loader mr-2", { "hidden": !isLoading })}></div>
    {text ? text : "Load More"}
  </button>
}

export {
  Button,
  LoadButton
}